import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../../../../services';
import { AppState, RemovedBallanceReport, Store } from '../../../../store';
import { ReportBase } from '../report.base';

@Component({
  selector: 'app-removed-ballances-report',
  templateUrl: './removed-ballances-report.component.html',
  styleUrls: ['./removed-ballances-report.component.css']
})
export class RemovedBallancesReportComponent extends ReportBase implements OnInit {

  report: RemovedBallanceReport;
  controls = [
    { name: 'name', type: 'text', title: 'Name' },
    { name: 'date', type: 'date', title: 'Date' },
    { name: 'gender', type: 'select', title: 'Gender', options: [ { text: 'Male', value: 'm' }, { text: 'Female', value: 'f' } ] },
    { name: 'fee', type: 'text', title: 'Fee' },
    { name: 'removedBy', type: 'text', title: 'By' },
    { name: 'reason', type: 'text', title: 'Reason' },
    { name: 'amount', type: 'number', title: 'Amount' }
  ];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.pullData('getRemovedBallancesReportData');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/removed-ballances-report/removed-ballances-report.component.ts